module.exports = __webpack_public_path__ + "media/bg.56d4e587.mp4";